import { FeatureFlags } from '@fabric-ui/components';
import { CURRENT_STATUS_FIELD } from '@shared/Tickets/utils';
import { createFileRoute } from '@tanstack/react-router';
import { entityProjectionNames } from '@utils/entityProjectionNames';
import { ACTIONS_MAP } from '@utils/entityViewConfig';
import { getIsManualOverrideEnabled } from '@views/ModelManagement/hooks';
import { Permission, PermissionAppName, PermissionEntitiesNames } from '../../../../types';
import { TFieldRegulation } from '../../../../views/ModelManagement/types';

type HasAllowedPermissionToResource = (options: {
  category: PermissionAppName;
  resource: PermissionEntitiesNames;
  permission: Permission;
}) => boolean;

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/identities')({
  beforeLoad: ({ context, preload }) => {
    context.validateAppPermission('IDENTITIES', preload);

    const isIdentityFindingExceptionsEnabled = !!context.featureFlags[FeatureFlags.IdentityFindingExceptions];

    return {
      isIdentityFindingExceptionsEnabled,
      shouldAllowAction: (projectionName: string, action: string) => {
        const isExceptionAction = action === ACTIONS_MAP.EXCEPTIONS_SECTION || action === ACTIONS_MAP.EXCEPTIONS_FORM;
        if (isExceptionAction) {
          return isIdentityFindingExceptionsEnabled || projectionName === entityProjectionNames.IdentityFinding;
        }
        return true;
      },
      canManageExceptions: (hasAllowedPermissionToResource: HasAllowedPermissionToResource, fieldRegulations: TFieldRegulation[]) =>
        hasAllowedPermissionToResource({
          category: PermissionAppName.IDENTITIES,
          resource: PermissionEntitiesNames.EXCEPTION,
          permission: Permission.AUDIT,
        }) && getIsManualOverrideEnabled(CURRENT_STATUS_FIELD, entityProjectionNames.Exception, fieldRegulations),
    };
  },
});
